const Button = ({
  label,
  onClick,
  secondary = false,
  type = 'button',
  disabled = false,
}: {
  type?: 'button' | 'submit' | 'reset' | undefined;
  secondary?: boolean;
  label?: string;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  const variant = secondary ? 'nl-btn--secondary' : 'nl-btn--primary';

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`nl-btn ${variant}`}
    >
      {label}
    </button>
  );
};

export default Button;
